const KEY = 'PERMISSION';

export { KEY };
